export default __webpack_public_path__ + "static/issues_codebook-a946d4e6f2d4179dc4d682064ce3cae8.pdf";